"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Kurt_1 = __importDefault(require("./Kurt"));
var Prescription01_1 = __importDefault(require("./Prescription01"));
var Prescription02_1 = __importDefault(require("./Prescription02"));
var Round_1 = __importDefault(require("./Round"));
var Sunglasses_1 = __importDefault(require("./Sunglasses"));
var Wayfarers_1 = __importDefault(require("./Wayfarers"));
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("../../AvatarContext"));
var AccessoriesType_1 = __importDefault(require("./AccessoriesType"));
function Accessory() {
    var type = react_1.useContext(AvatarContext_1.default).accessoriesType;
    switch (type) {
        case AccessoriesType_1.default.Kurt:
            return jsx_runtime_1.jsx(Kurt_1.default, {}, void 0);
        case AccessoriesType_1.default.Prescription01:
            return jsx_runtime_1.jsx(Prescription01_1.default, {}, void 0);
        case AccessoriesType_1.default.Prescription02:
            return jsx_runtime_1.jsx(Prescription02_1.default, {}, void 0);
        case AccessoriesType_1.default.Round:
            return jsx_runtime_1.jsx(Round_1.default, {}, void 0);
        case AccessoriesType_1.default.Sunglasses:
            return jsx_runtime_1.jsx(Sunglasses_1.default, {}, void 0);
        case AccessoriesType_1.default.Wayfarers:
            return jsx_runtime_1.jsx(Wayfarers_1.default, {}, void 0);
        default:
            return null;
    }
}
exports.default = Accessory;
